import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {getToken} from "@shared/helpers";
import {AuthenticationNs} from "@shared/types";
import {useWorkspaceStore} from "@shared/stores/workspace.store";


export const authenticationGuard = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
): Promise<void> => {

    // Check Authentication
    const requiresAuth = (to.meta.requiresAuth === undefined || to.meta.requiresAuth);
    if (requiresAuth) {
        const token = getToken();
        if (!token.accessToken) {
            next({name: AuthenticationNs.AuthenticationRouteEnums.SignIn});
            return;
        }
    }

  // Check Authorization
  const userRoles = to.meta.userRole as string[]
  if (userRoles) {
    const wsStore = useWorkspaceStore()
    const userRole = wsStore.getWorkspaceRole;
    if (!userRoles.includes(userRole)) {
      next(false);
      return;
    }
  }

  // Keep going
  next();
};
